angular.module('impactx.search').component('ixSupplierList', {
        bindings: {
            suppliers: '<',
            trns: '<',
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'SupplierSearchListCtrl',
        controllerAs: 'supplierSearchListCtrl',
        templateUrl: 'modules/search/templates/supplier-list.html'
    }
);